export const CONTACT_PAGE = 'crm/CONTACT_PAGE'
export const CONTACTS_PAGE = 'crm/CONTACTS_PAGE'
export const COMPANIES_PAGE = 'crm/COMPANIES_PAGE'
export const COMPANY_PAGE = 'crm/COMPANY_PAGE'
export const INDEX_PAGE = 'crm/INDEX_PAGE'
